<script>
  const chevron_right = "/assets_default/icons/chevron_right.svg"
  import { createNewsState } from '@modules/FetchInformation.svelte.js';
  const filterBizNews = news => news.business === 1 || news.businessTicker === 1
  const newsState = createNewsState(filterBizNews);
  const displayCount = 3;
  let newsToShow = $derived(newsState.newsList.slice(0, displayCount));
</script>

<section class="owd-biz-section:max:1200 owd-biz-section:spacing-bottom" id="news">
  <section-head biz="true" title="お知らせ" caption="NEWS"></section-head>
  <div class="owd-biz-inner:contents">
    {#if newsState.isLoading}
    <p class="owd-text:01 spacing:bottom:24">ローディング中</p>
    {:else if newsState.error}
    <p class="owd-text:01 spacing:bottom:24">{newsState.error}</p>
    {:else if newsToShow.length > 0}
    <ul class="owd-biz-newslist">
      {#each newsToShow as news}
      <li class="owd-biz-newslist-item">
        <a href={news.url} target="_blank" class="owd-biz-newslist-item-flex">
          <div class="owd-biz-newslist-item-textarea">
            <div class="owd-biz-newslist-item-labelarea">
              <p class="owd-biz-newslist-item-date owd-text:02"><strong>{news.date}</strong></p>
              <div class="owd-servicesticker block:center">
                <p class="text-color:white owd-label">{news.category}</p>
              </div>
            </div>
            <p class="owd-text:01">{news.title}</p>
          </div>
          <img src={chevron_right} alt="右矢印アイコン">
        </a>
      </li>
      {/each}
    </ul>
    {:else}
    <p class="owd-text:01 spacing:bottom:24">お知らせはありません。</p>
    {/if}
    <button-biz url="https://corporate.minna-no-ginko.com/information/" title="お知らせ一覧を見る" type="secondary:white" blank single></button-biz>
  </div>
</section>

<style lang="scss">
.owd-biz-newslist{
  margin-bottom: 48px;
  @include g.mobile () {
    margin-bottom: 32px;
  }
}
</style>
